import { render, staticRenderFns } from "./NavigationDrawer.vue?vue&type=template&id=c6488aa8&scoped=true"
import script from "./NavigationDrawer.vue?vue&type=script&lang=ts"
export * from "./NavigationDrawer.vue?vue&type=script&lang=ts"
import style0 from "./NavigationDrawer.vue?vue&type=style&index=0&id=c6488aa8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6488aa8",
  null
  
)

export default component.exports